import React from 'react';
import { Award, Users, Star } from 'lucide-react';
import { clinicInfo } from '../data/servicesData';

const TrustIndicators = () => {
  const indicators = [
    {
      icon: Award,
      value: `${clinicInfo.experience} Years`,
      label: "of Experience"
    },
    {
      icon: Users,
      value: `${clinicInfo.happySmiles}`,
      label: "Happy Smiles"
    },
    {
      icon: Star,
      value: `${clinicInfo.rating}★`,
      label: "Google Rating"
    }
  ];

  return (
    <div className="trust-indicators">
      {indicators.map((item, index) => {
        const Icon = item.icon;
        return (
          <div key={index} className="trust-item">
            <Icon className="trust-icon" size={32} />
            <div className="trust-value">{item.value}</div>
            <div className="trust-label">{item.label}</div>
          </div>
        );
      })}
    </div>
  );
};

export default TrustIndicators;
